import {
  RainbowUnderLineDiv,
  RainbowUnderlineInDiv,
} from './RainbowUnderLine.style'

export const RainbowUnderLine = ({
  lineColor,
  height,
  hideElement,
  elementWidth,
  elementLeft,
  position,
}: {
  hideElement?: boolean
  lineColor?: string
  height?: number
  elementWidth?: number
  elementLeft?: number
  position?: 'relative' | 'absolute'
}) => {
  return (
    <RainbowUnderLineDiv
      background={lineColor ? lineColor : '#00104a'}
      height={height ? height : 3}
      position={position ? position : 'relative'}
    >
      {!hideElement && (
        <RainbowUnderlineInDiv
          width={elementWidth ? elementWidth : 20}
          left={elementLeft ? elementLeft : 15}
        />
      )}
    </RainbowUnderLineDiv>
  )
}
